module.exports = __webpack_public_path__ + "static/MouliEdwardMD-eaeb02a2be6c893b6fbe86285e46ef76.jpg";